import * as ActionTypeIds from 'automation-ui-action-features/constants/ActionTypeIds';
import { isObjectTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import memoize from 'transmute/memoize';
import { actionRecommendationSupportedObjectTypeIds } from 'automation-ui-canvas/components/canvas/next-action-recommender/constants/actionRecommendationSupportedObjectTypeIds';
export const shouldShowActionRecommendation = memoize((ancestorActionTypeIds, flowObjectTypeId) => {
  if (!flowObjectTypeId || !isObjectTypeId(flowObjectTypeId) || !actionRecommendationSupportedObjectTypeIds[flowObjectTypeId]) {
    return false;
  }
  const historyDepth = 4;
  // the ancestorActionTypeIds are from the enrollment to the current action
  // get the last four since that's all we care about for now
  const recentActionTypeIds = ancestorActionTypeIds.slice(-historyDepth);
  const validActionTypeIds = new Set(Object.values(ActionTypeIds));
  // Extension type actions are not supported in v1 of the Next Action Recommender
  validActionTypeIds.delete(ActionTypeIds.EXTENSION);
  return recentActionTypeIds.every(actionTypeId => validActionTypeIds.has(actionTypeId));
}, (ancestorActionTypeIds, flowObjectTypeId) => `${ancestorActionTypeIds.join('_')}-${String(flowObjectTypeId)}`);